import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions("us-central1");

/**
 * Prefer the callable's server message over a generic client fallback.
 */
export function getHttpsCallableErrorMessage(error, fallback) {
  const candidates = [error?.details, error?.message, error?.cause?.message];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return fallback;
}

/**
 * Platform-admin only: set organizations/{orgId}.partnerTier + foundingPartnerId.
 */
export async function setInstitutionPartnerTier({
  organizationId,
  partnerTier,
  foundingPartnerId = null,
}) {
  const callable = getFunctions().httpsCallable("setInstitutionPartnerTier");
  const result = await callable({
    organizationId,
    partnerTier,
    foundingPartnerId,
  });
  return result.data;
}

/**
 * Founding Partner admin: list per-query Fusion Partner P3 edit locks.
 * Missing promptIds are allowed by default (no document).
 */
export async function listFusionPromptEditPermissions() {
  const callable = getFunctions().httpsCallable(
    "listFusionPromptEditPermissions",
  );
  const result = await callable();
  return result.data;
}

/**
 * Founding Partner admin: set whether Fusion Partners may edit a query's P3.
 */
export async function setFusionPromptEditPermission({ promptId, allowed }) {
  const callable = getFunctions().httpsCallable(
    "setFusionPromptEditPermission",
  );
  const result = await callable({ promptId, allowed });
  return result.data;
}
